module.exports = __webpack_public_path__ + "fonts/fa-light-300.d3271a5.woff2";